import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#050505] py-16 px-6" data-testid="privacy-policy-page">
      <div className="max-w-2xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-neutral-500 hover:text-yellow-400 transition-colors text-sm mb-10">
          <ArrowLeft size={16} />
          Back to Website
        </Link>

        <div className="mb-10">
          <div className="text-lg font-black uppercase tracking-wider text-white mb-4">
            Charlesworth <span className="text-yellow-400">Club</span>
          </div>
          <h1 className="text-2xl font-bold text-white">Privacy Policy</h1>
          <p className="text-neutral-500 text-sm mt-1">Last updated: April 2026</p>
        </div>

        <div className="space-y-8 text-sm text-neutral-300 leading-relaxed">
          <section>
            <h2 className="text-white font-semibold text-base mb-2">Who we are</h2>
            <p>
              Charlesworth Club is a wedding and events supplier based in the UK. If you have any questions about how we handle your data, you can contact us at{" "}
              <a href="mailto:noah@charlesworth.club" className="text-yellow-400 hover:underline">noah@charlesworth.club</a>.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">What information we collect</h2>
            <p className="mb-3">
              When you enquire about our services — whether through our website, a Meta (Facebook/Instagram) lead form, or a third-party listing such as Hitched — we may collect:
            </p>
            <ul className="list-disc list-inside space-y-1 text-neutral-400">
              <li>Your name</li>
              <li>Your email address</li>
              <li>Your phone number</li>
              <li>Details about your event (date, budget, requirements)</li>
            </ul>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">Why we collect it</h2>
            <p>
              We collect this information solely to respond to your enquiry and provide you with a quote or information about our services. We do not use your data for any other purpose without your consent.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">How we store it</h2>
            <p>
              Your information is stored securely. We do not sell, rent, or share your personal data with any third parties. Data submitted via Meta lead forms is processed by Meta Platforms in accordance with their own privacy policy.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">How long we keep it</h2>
            <p>
              We keep your enquiry details for up to 24 months. If you would like your data deleted before this, simply email us and we will remove it within 7 days.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">Your rights</h2>
            <p className="mb-3">Under UK GDPR you have the right to:</p>
            <ul className="list-disc list-inside space-y-1 text-neutral-400">
              <li>Access the personal data we hold about you</li>
              <li>Request correction of inaccurate data</li>
              <li>Request deletion of your data</li>
              <li>Withdraw consent at any time</li>
            </ul>
            <p className="mt-3">
              To exercise any of these rights, contact us at{" "}
              <a href="mailto:noah@charlesworth.club" className="text-yellow-400 hover:underline">noah@charlesworth.club</a>.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">Cookies</h2>
            <p>
              This website does not currently use tracking cookies. If this changes, this policy will be updated.
            </p>
          </section>

          <section>
            <h2 className="text-white font-semibold text-base mb-2">Changes to this policy</h2>
            <p>
              We may update this policy from time to time. The date at the top of this page will always reflect the most recent version.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-neutral-600 text-xs">Charlesworth Club - Mobile Bar & DJ for Private Events</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
